import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function fetchDropboxUsers(dropboxId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes/${dropboxId}/users`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.users.js
 **/